var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "8px",
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4C826137-7D2D-4A3C-A7F9-F52FA58C475C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Message-Center--Message-Selected",
    transform: "translate(-512.000000, -237.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pin",
    transform: "translate(512.258121, 237.519861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.90100204,0.226671512 C4.19412696,-0.0664534053 4.68089413,-0.0845258802 4.99910469,0.226671512 L6.92078432,2.14835114 C7.224017,2.45158381 7.224017,2.94322111 6.92078432,3.24645379 C6.6276594,3.53957872 6.14091292,3.56110381 5.82268166,3.24645379 L5.68543397,3.10912121 L4.53954977,4.25500542 C4.88523546,5.19058821 4.65379295,6.34516591 3.90100204,7.08981306 C3.8197398,7.17019619 3.69466845,7.15972902 3.62647637,7.08981306 L1.97924705,5.44253668 L0.743956927,6.67802456 C0.668148759,6.75383273 0.545239433,6.75383273 0.469431265,6.67802456 C0.399454493,6.6080478 0.387158047,6.48644934 0.469431265,6.40349891 L1.70476285,5.16805247 L0.0576427713,3.52097946 C-0.0123339991,3.45100268 -0.0258001515,3.32989672 0.0576427713,3.24645379 C0.792124199,2.51197236 1.90773122,2.24909027 2.8922563,2.60771195 L4.0381405,1.46182774 L3.90100204,1.32477417 C3.58811198,1.01027154 3.60787711,0.519796429 3.90100204,0.226671512 Z M4.72457902,0.501197173 C4.57296269,0.349580837 4.32714405,0.349580837 4.17552771,0.501197173 C4.03189117,0.644833702 4.01825373,0.888315512 4.17552771,1.0502485 L4.45005336,1.32477417 C4.52002862,1.39474941 4.52990277,1.51923171 4.45005336,1.59929562 L3.07799287,2.97144417 C3.02259366,3.02684676 2.93932005,3.04351473 2.86686451,3.01370342 C2.10325131,2.69952031 1.180486,2.79010829 0.475087042,3.38942899 L3.75783273,6.67217467 C4.32840935,6.01201888 4.45005336,5.0184131 4.13380962,4.28073037 C4.09712809,4.19516559 4.13380962,4.11156872 4.17552771,4.06962433 L5.54814957,2.69740892 C5.61812538,2.62742653 5.73846228,2.61571506 5.82268166,2.69740892 L6.09720733,2.97192812 C6.24882367,3.12354446 6.49464231,3.12354446 6.64625865,2.97192812 C6.78989519,2.82829161 6.80528907,2.58584604 6.64625865,2.4228768 L4.72457902,0.501197173 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.143b0c259a5b5ef0708483abde4bdea1.svg";
export { ForwardRef as ReactComponent };